module.exports = __webpack_public_path__ + "static/media/042.217b943a.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/042.wav
 ** module id = 174
 ** module chunks = 0
 **/